module.exports = __webpack_public_path__ + "static/media/0224_IMG_LA_POISSONNERIE.9ee3c437.webp";